// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddOptionsModalV2QueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type AddOptionsModalV2Query = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, globalOption: { __typename?: 'GlobalOption', id: string }, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string } | null | undefined }>, roomLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, name: string }>, designPackages: Array<{ __typename?: 'DesignPackage', id: string }> } };

export type AddOptionsModalV2_GlobalOptionsQueryVariables = Types.Exact<{
  filter: Types.GlobalOptionsFilter;
}>;


export type AddOptionsModalV2_GlobalOptionsQuery = { __typename?: 'Query', globalOptions: Array<{ __typename?: 'GlobalOption', id: string, code: string, displayName: string, lastUsedAt?: Types.Scalars['DateTime']['input'] | null | undefined, type: { __typename?: 'GlobalOptionType', id: string, name: string, allowsLocations: boolean } }> };

export type AddOptionsModalV2_GlobalOptionFragment = { __typename?: 'GlobalOption', id: string, code: string, displayName: string, lastUsedAt?: Types.Scalars['DateTime']['input'] | null | undefined, type: { __typename?: 'GlobalOptionType', id: string, name: string, allowsLocations: boolean } };

export const AddOptionsModalV2_GlobalOptionFragmentDoc = gql`
    fragment AddOptionsModalV2_GlobalOption on GlobalOption {
  id
  code
  displayName
  lastUsedAt
  type {
    id
    name
    allowsLocations
  }
}
    `;
export const AddOptionsModalV2Document = gql`
    query AddOptionsModalV2($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    id
    version {
      id
    }
    options(includeInactive: true) {
      id
      active
      globalOption {
        id
      }
      readyPlanLocation {
        id
      }
    }
    roomLocations(filter: {locationType: [GROUP, ROOM, LEVEL]}) {
      id
      name
    }
    designPackages {
      id
    }
  }
}
    `;

/**
 * __useAddOptionsModalV2Query__
 *
 * To run a query within a React component, call `useAddOptionsModalV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAddOptionsModalV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddOptionsModalV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useAddOptionsModalV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<AddOptionsModalV2Query, AddOptionsModalV2QueryVariables> & ({ variables: AddOptionsModalV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddOptionsModalV2Query, AddOptionsModalV2QueryVariables>(AddOptionsModalV2Document, options);
      }
export function useAddOptionsModalV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddOptionsModalV2Query, AddOptionsModalV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddOptionsModalV2Query, AddOptionsModalV2QueryVariables>(AddOptionsModalV2Document, options);
        }
// @ts-ignore
export function useAddOptionsModalV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddOptionsModalV2Query, AddOptionsModalV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddOptionsModalV2Query, AddOptionsModalV2QueryVariables>;
export function useAddOptionsModalV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddOptionsModalV2Query, AddOptionsModalV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddOptionsModalV2Query | undefined, AddOptionsModalV2QueryVariables>;
export function useAddOptionsModalV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddOptionsModalV2Query, AddOptionsModalV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddOptionsModalV2Query, AddOptionsModalV2QueryVariables>(AddOptionsModalV2Document, options);
        }
export type AddOptionsModalV2QueryHookResult = ReturnType<typeof useAddOptionsModalV2Query>;
export type AddOptionsModalV2LazyQueryHookResult = ReturnType<typeof useAddOptionsModalV2LazyQuery>;
export type AddOptionsModalV2SuspenseQueryHookResult = ReturnType<typeof useAddOptionsModalV2SuspenseQuery>;
export type AddOptionsModalV2QueryResult = ApolloReactCommon.QueryResult<AddOptionsModalV2Query, AddOptionsModalV2QueryVariables>;
export const AddOptionsModalV2_GlobalOptionsDocument = gql`
    query AddOptionsModalV2_GlobalOptions($filter: GlobalOptionsFilter!) {
  globalOptions(filter: $filter) {
    ...AddOptionsModalV2_GlobalOption
  }
}
    ${AddOptionsModalV2_GlobalOptionFragmentDoc}`;

/**
 * __useAddOptionsModalV2_GlobalOptionsQuery__
 *
 * To run a query within a React component, call `useAddOptionsModalV2_GlobalOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddOptionsModalV2_GlobalOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddOptionsModalV2_GlobalOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAddOptionsModalV2_GlobalOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddOptionsModalV2_GlobalOptionsQuery, AddOptionsModalV2_GlobalOptionsQueryVariables> & ({ variables: AddOptionsModalV2_GlobalOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddOptionsModalV2_GlobalOptionsQuery, AddOptionsModalV2_GlobalOptionsQueryVariables>(AddOptionsModalV2_GlobalOptionsDocument, options);
      }
export function useAddOptionsModalV2_GlobalOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddOptionsModalV2_GlobalOptionsQuery, AddOptionsModalV2_GlobalOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddOptionsModalV2_GlobalOptionsQuery, AddOptionsModalV2_GlobalOptionsQueryVariables>(AddOptionsModalV2_GlobalOptionsDocument, options);
        }
// @ts-ignore
export function useAddOptionsModalV2_GlobalOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddOptionsModalV2_GlobalOptionsQuery, AddOptionsModalV2_GlobalOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddOptionsModalV2_GlobalOptionsQuery, AddOptionsModalV2_GlobalOptionsQueryVariables>;
export function useAddOptionsModalV2_GlobalOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddOptionsModalV2_GlobalOptionsQuery, AddOptionsModalV2_GlobalOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddOptionsModalV2_GlobalOptionsQuery | undefined, AddOptionsModalV2_GlobalOptionsQueryVariables>;
export function useAddOptionsModalV2_GlobalOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddOptionsModalV2_GlobalOptionsQuery, AddOptionsModalV2_GlobalOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddOptionsModalV2_GlobalOptionsQuery, AddOptionsModalV2_GlobalOptionsQueryVariables>(AddOptionsModalV2_GlobalOptionsDocument, options);
        }
export type AddOptionsModalV2_GlobalOptionsQueryHookResult = ReturnType<typeof useAddOptionsModalV2_GlobalOptionsQuery>;
export type AddOptionsModalV2_GlobalOptionsLazyQueryHookResult = ReturnType<typeof useAddOptionsModalV2_GlobalOptionsLazyQuery>;
export type AddOptionsModalV2_GlobalOptionsSuspenseQueryHookResult = ReturnType<typeof useAddOptionsModalV2_GlobalOptionsSuspenseQuery>;
export type AddOptionsModalV2_GlobalOptionsQueryResult = ApolloReactCommon.QueryResult<AddOptionsModalV2_GlobalOptionsQuery, AddOptionsModalV2_GlobalOptionsQueryVariables>;